import React, { useState, useEffect } from "react";
import "..//Styles/paymentGateway.css";
import Logo from "..//Assets/logo.png";
import QR from "..//Assets/qr.png"
import CopyButton from "..//Assets/copy.png";
import { Dropdown } from "semantic-ui-react";
import QRCode from 'react-qr-code';

const coinOptions = [
  {
    key: "Bitcoin",
    text: "Bitcoin",
    value: "Bitcoin",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=63192&format=png",
    },
  },
  {
    key: "Ethereum",
    text: "Ethereum",
    value: "Ethereum",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=IhWBOFHtv6vx&format=png",
    },
  },
  {
    key: "Cardano",
    text: "Cardano",
    value: "Cardano",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=xnZMZXqLEDk1&format=png",
    },
  },
  {
    key: "Binance",
    text: "Binance",
    value: "Binance",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=74XminJ8M1Qo&format=png",
    },
  },
  {
    key: "Litecoin",
    text: "Litecoin",
    value: "Litecoin",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=xqQrllrLPHoc&format=png",
    },
  },
  {
    key: "Litecoin",
    text: "Litecoin",
    value: "Litecoin",
    image: {
      avatar: true,
      src: "https://cdn.iconscout.com/icon/free/png-256/polygon-token-4086724-3379854.png",
    },
  },
  {
    key: "Dogecoin",
    text: "Dogecoin",
    value: "Dogecoin",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=5BZmf_27QkFi&format=png",
    },
  },
  {
    key: "Tether",
    text: "Tether",
    value: "Tether",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=U8V97McJaXmr&format=png",
    },
  },
  {
    key: "TRON",
    text: "TRON",
    value: "TRON",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=Thy2EqtAN9ki&format=png",
    },
  },
  {
    key: "Dai",
    text: "Dai",
    value: "Dai",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=uTORsq2rEgtH&format=png",
    },
  },
  {
    key: "XRP",
    text: "XRP",
    value: "XRP",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=EotgtbkKqbyd&format=png",
    },
  },
  {
    key: "SHIBA INU",
    text: "SHIBA INU",
    value: "SHIBA INU",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=TO7tQS2Frpif&format=png",
    },
  },
  {
    key: "USDC",
    text: "USDC",
    value: "USDC",
    image: {
      avatar: true,
      src: "https://img.icons8.com/?size=512&id=1jPxlShNofZt&format=png",
    },
  },
];
const chainOptions = [
  {
    key: "Ethereum",
    text: "Ethereum",
    value: "Ethereum",
    image: {
      avatar: true,
      src: "data:image/png;base64,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",
    },
  },
  {
    key: "Binance Chain",
    text: "Binance Chain",
    value: "Binance Chain",
    image: {
      avatar: true,
      src: "https://seeklogo.com/images/B/binance-coin-bnb-logo-CD94CC6D31-seeklogo.com.png",
    },
  },
  {
    key: "Binance Smart Chain",
    text: "Binance Smart Chain",
    value: "Binance Smart Chain",
    image: {
      avatar: true,
      src: "data:image/png;base64,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",
    },
  },
  {
    key: "Polygon",
    text: "Polygon",
    value: "Polygon",
    image: {
      avatar: true,
      src: "https://altcoinsbox.com/wp-content/uploads/2023/03/matic-logo.jpg",
    },
  },
];
const App = (props) => {
  const [step, setStep] = useState(1);
  const [billing_address, setbilling_address] = useState("")
  const [amount, setamount] = useState(0)
  const [user, setuser] = useState("")
  const [start_time, setstart_time] = useState("")
  const [phone, setphone] = useState("")
  const [pay_address, setPay_address] = useState("")
  const [order_id, setorder_id] = useState("")
  const [email, setemail] = useState("")
  const [totalAmount] = useState("$30.00");
  const [wallet] = useState("");
  const [selectedCoin, setSelectedCoin] = useState(props.selectedCoin);
  const [selectedChain, setSelectedChain] = useState(props.selectedChain);
  const [selectedEmail, SetselectedEmail] = useState("");
  const [text] = useState("652123455594939213xvbad436683sbcbsnmfo97653784bfcdrdfgtyhjjcgbdf51342");
  const [copied, setCopied] = useState(false);
  const [remainingTime, setRemainingTime] = useState(1200);
  const queryString = window.location.search;
  const query = new URLSearchParams(queryString);
  const token = query.get('token')
  const requestOptions = {
    method: "GET",
    redirect: "follow"
  };

  useEffect(() => {
    fetch("https://paymentgatewaymicroservice-120551421124.us-central1.run.app/front/"+token+"/?format=json", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      console.log(result["billing_address"]);
      setbilling_address(result["billing_address"])
      setamount(result["vista_amount"])
      setPay_address(result["dep"])
    })
    .catch((error) => console.error(error));
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  function formatTime(timeInSeconds) {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  }

  const handleDropdownChange = (e, { value }) => {
    setSelectedCoin(value);
  };
  const handleDropdownChange2 = (e, { value }) => {
    setSelectedChain(value);
  };

  const onNextStep = () => {
    setStep(step + 1);
  };

  const onPrevStep = () => {
    setStep(step - 1);
  };
  const handleChange = (event) => {
    SetselectedEmail(event.target.value);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(pay_address);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000); // Reset the copied state after 3 seconds
  };
  return (
    <div className="container">
      {step === 1 && (
        <div className="invoice-container">
          <div className="invoice-container">
            <h2>Step 1: Enter Amount</h2>
            <div className="logo-container">
              <img src={Logo} alt="Company Logo" />
            </div>
            <div className="invoice-to-container">
              {/* <p>Start Date : 02/05/2023</p>
              <p>Due Date : 10/05/2023</p> */}
            </div>
            <div className="invoice-sections-container">
              <div className="invoice-to-container">
                <h3>Invoice To</h3>
                <p></p>
                <p></p>
                <p>{billing_address}</p>
                <p></p>
                <p></p>
              </div>
              <div className="pay-to-container">
                <h3>Pay To</h3>
                <p>Vista Battle</p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
              </div>
            </div>
            <div className="invoice-items-container">
              <table>
                <thead>
                  <tr>
                    <th>Item Description</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      Base system$148.24 CPU: AMD EPYC™ 7402P 24C/48T (128M
                      Cache, 2.80 GHz) $131.77$131.77 <br></br>
                      RAM: 32GB DDR4 ECC $19.77$19.77<br></br>
                      DISK: 2.5" 240GB Enterprise SSD: 2 x $7.69$15.38<br></br>
                      RAID Array: RAID 1 (Mirroring)<br></br>
                      OS: Linux OS<br></br>
                      Linux OS: Ubuntu 22.04 LTS 64-bit<br></br>
                      IPv4 Address: 1 IP address<br></br>
                      IPv6 Address: 1 IPv6 address<br></br>
                      Internet speed: 1Gbps (100TB traffic inc.)
                    </td>
                    <td>Vista {amount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="grand-total-container">
              <h3>Grand Total:</h3>
              <p>Vista {amount}</p>
            </div>
          </div>
          <div className="btn-mid-container">
            <button onClick={onNextStep}>Pay Now</button>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="invoice-container">
          <div className="logo-container">
            <img src={Logo} alt="Company Logo" />
          </div>
          <h2>Step 2: Enter your email</h2>
          <span className="span-text">
            Email needed for VistaGate receipt and refund
          </span>
          <input
            onChange={handleChange}
            value={selectedEmail}
            type="text"
            placeholder="Enter your Email Address"
          />

          <div></div>
          <div className="button-container">
            <button onClick={onPrevStep}>Back</button>
            <button onClick={onNextStep}>Continue wihtout email</button>
          </div>
        </div>
      )}
      {step === 3 && (
        <div className="payment-container">
          <div className="logo-container">
            <img src={Logo} alt="Company Logo" />
          </div>
          <h2>Step 3: Pay for your Order</h2>
          <span className="span-text">
            Scan the QR code or copy the payment details in to your wallet
          </span>
          <br></br>
          <QRCode
                        title="GeeksForGeeks"
                        value={pay_address}
                    />
          <div className="walletaddress">
            <div className="flex-grow-1">
              <b>Address: </b>
              {pay_address.length > 25 ? (
                <>
                  {pay_address.slice(0, 20)}
                  {"{...}"}
                  {pay_address.slice(-8)}
                </>
              ) : (
                <>{pay_address}</>
              )}
            </div>
            <img
              className="cursor"
              onClick={handleCopy}
              src={CopyButton}
              alt="copy-button"
            />
          </div>
          {copied && <div> Address Copied!</div>}
          <div className="walletaddress">
            <b> Amount:</b> {amount}
          </div>
          <div className="walletaddress">
            <b> Coin: Vista (BEP20)</b>
            {selectedCoin}
          </div>
          <div className="walletaddress">
            <b> Chain:</b> Binance Smart Chain
          </div>
          <div className="walletaddress">
            <b> Email:</b> {selectedEmail}
          </div>

          <div className="step4-button-container">
            <button onClick={onPrevStep}>Back</button>
            <button>{formatTime(remainingTime)}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
